import { Component, Input, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "src/app/state/app.state";
import { getTitle, getTitleSecondary, getTitleThird } from "../state/title.selectors";

@Component({
    selector: "app-title",
    templateUrl: "./title.component.html",
    styleUrls: ["./title.component.scss"],
    standalone: false
})
export class TitleComponent {
	public title$: Observable<string> = this.store.pipe(select(getTitle));
	public title_secondary$: Observable<string> = this.store.pipe(select(getTitleSecondary));
	public title_third$: Observable<string> = this.store.pipe(select(getTitleThird));
	@Input() noTranslate: boolean;

	constructor(private store: Store<AppState>) {}
}
